import Illustration from '@components/Illustration';
import Section from '@components/Section';
import Text from '@components/Text';
import Title from '@components/Title';
import Underline from '@components/Underline';
import React from 'react';
import { StyledHero } from './styled';

interface IHeroProps {
  children?: React.ReactNode;
}


const Hero:React.FC<IHeroProps> = (props) => {

  return (
    <Section scrollerId='Skills & Tools'>
      <StyledHero>
        <div>
          <Title size={66}>
            Hi, <br />
            I&apos;m Nik
          </Title>
          <Text>
            a <Underline>React developer</Underline>
          </Text>
          <Text>
            Welcome to my portfolio
          </Text>
        </div>
        <Illustration />
      </StyledHero>
    </Section>
  );
}

export default Hero;
